import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { TMSLocation } from 'types/Load';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type GetLocationsResponse = {
  locationList: TMSLocation[];
  tmsTenant: string;
  message: string;
};

/**
 * Fetch locations. For TMS like 3G, locations are per-customer: pass customerExternalTmsId to filter.
 * For others, omit both to get unfiltered locations.
 * Caller sends at most one: customerExternalTmsId (e.g. 3G form) or customerID (internal id).
 */
export async function getLocations(
  tmsID: number,
  forceRefresh?: boolean,
  changeHostName?: boolean,
  customerExternalTmsId?: string,
  customerID?: number
): Promise<Result<GetLocationsResponse, ApiError>> {
  try {
    const queryParams = new URLSearchParams({
      tmsID: tmsID.toString(),
    });
    if (forceRefresh) queryParams.append('forceRefresh', 'true');
    if (changeHostName) queryParams.append('changeHostName', 'true');
    if (customerExternalTmsId != null && customerExternalTmsId !== '') {
      queryParams.append('customerExternalTmsId', customerExternalTmsId);
    } else if (customerID != null) {
      queryParams.append('customerID', String(customerID));
    }

    const response = await axios.get<GetLocationsResponse>(
      `/locations?${queryParams.toString()}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getLocations' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get list of locations from TMS' });
    }

    return err({
      message:
        error.response?.data?.message ||
        'Failed to get list of locations from TMS',
      status: error.response?.status,
    });
  }
}
